import { createFileRoute } from "@tanstack/react-router";
import { pauseQueryOptions } from "../app/queries/pauseQueries";
import { Unfinished } from "../app/views/unfinished/unfinished";

export const Route = createFileRoute("/unfinished")({
  component: Unfinished,
  loader: async ({ context: { queryClient } }) => {
    queryClient.ensureQueryData(pauseQueryOptions);
  },
});
